import { Subject } from "rxjs";

export class ContactWorkEmail {
  emailoption: any;
  emailstring: string;
}
export class ContactHomePhone {
  phoneoption: any;
  phonestring: string;
}
export class Tcontactworkemail {
  emailoption1: number;
  emailoption2: number;
  emailoption3: number;
  emailstring1: string;
  emailstring2: string;
  emailstring3: string;
}
export class Tcontacthomephone {
  phoneoption1: number;
  phoneoption2: number;
  phoneoption3: number;
  phonestring1: string;
  phonestring2: string;
  phonestring3: string;
  phonebookmark1: boolean;
  phonebookmark2: boolean;
  phonebookmark3: boolean;
}
export class FilterModel {
  status: string;
  value: string;
  type: string;
  id: string;
}

export class ClientFilterModel {
  Filters: string;
  ViewId: any;
}
export class ClientSortModel {
  field: string = '';
  direction: string = '';
}
export interface ContactList {
  backgroundColor: string,
  clientCount: number,
  contactId: number,
  email: string,
  isArchived: boolean,
  isDeleted: boolean,
  location: string,
  name: string,
  phone: string,
  shirtName: string,
  state: string,
  textColor: string
  countryId: number
}
export class ClientAddressBulkModel {
  public physicaladdressline1: string;
  public physicaladdressline2: string;
  public physicalsuburb: string;
  public physicalstate: any;
  public physicalcountry: string;
  public physicalpostcode: string;

  public postaladdressline1: string;
  public postaladdressline2: string;
  public postalsuburb: string;
  public postalstate: any;
  public postalpostcode: string;
  public postalcountry: string;
  public isSamePhysical: boolean = true; 
}

export class DynaicFilterPost {
  FilterId: number;
  SavedFilterName: string;
  Status: string;
  EntityTypeName: string;
  Tag: string;
  Location: string;
  Partner: string;
  Manager: string;
  TaxAgent: string;
  Contact: string;
  Industry: string;
  ActiveJob: string;
  OppurtunityJob: string;
  LastActivityDate: string;
  FollowupDate: string;
  LastInvoiceDate: string;
  WIP: string;
  AnnualIncome: string;
  GstRegisted: string;
  isTaxAgent: boolean = false;
  CreatedBy: string;
  isFavorite: boolean;
}

export interface Item {
  id: number;
  title: string
}

export class Clients {
  clientId: string;
  fullName: string;
  placeOfBirth: string;
  partnerName: string
  entityCounts: string;
  nextMeetingDate: string;
  openJobs: string;
}

export class ClientsDetail {
  clientIds: any;
  partnerId?: string;
  managerId?: string
  taxagentId?: string
  isTaxclient?: any;
  nextMeetingDate?: any;
  tagsId?: any;
  status?: any;
  contextFlag?: any;
  contextUser?: string;
  teamId?:any;
  public physicaladdressline1?: string;
  public physicaladdressline2?: string;
  public physicalsuburb?: string;
  public physicalstate?: any;
  public physicalcountry?: string;
  public physicalpostcode?: string;

  public postaladdressline1?: string;
  public postaladdressline2?: string;
  public postalsuburb?: string;
  public postalstate?: any;
  public postalpostcode?: string;
  public postalcountry?: string;
  public isSamePhysical?: boolean = true;  
}

export class WorkEmai {
  emailoption: string;
  emailstring: string;
  isemailbookmarked: boolean;
}

export class HomePhone {
  phoneoption: string;
  phonestring: string;
  isphonebookmarked: boolean;
}

export class TempWorkEmail {
  emailoption1: number;
  emailoption2: number;
  emailoption3: number;
  emailstring1: string;
  emailstring2: string;
  emailstring3: string
}

export class TempHomePhone {
  phoneoption1: number;
  phoneoption2: number;
  phoneoption3: number;
  phonestring1: string;
  phonestring2: string;
  phonestring3: string;
}

export class Entities {
  entityId: string;
  entityName: string;
  entityType: string;
  abn: string;
  primaryContact: string;
  taxAgent: string;
  manager: string;
  jobCount: string;
}

export class AssignEntity {
  id: any = 0;
  entityid: any;
  entityList: string;
  clientId: any;
  assignEntityIds: string;
}

export class Dynamicfilter {
  clientName: boolean = false; entityType: boolean = false;
  location: boolean = false; isShowpartnerName: boolean = false;
  isShowcontactName: boolean = false; isShowemail: boolean = false;
  isShowassignTagsCount: boolean = false;
  isShowclientCode: boolean = false; isShowmanager: boolean = false;
  isShowPartnername: boolean = false; isShowPartner: boolean = false;
  isShowinTaxClient: boolean = false; isShowtaxAgent: boolean = false;
  isShowcrmActivity: boolean = false; isShowworkPhone: boolean = false;
  isShowstatus: boolean = false; isShowabn: boolean = false;
  isShowopenJobs: boolean = false; isShowwip: boolean = false;
  isShowfollowUpDate: boolean = false; isShowlastActivityDate: boolean = true;
  isShowindustry: boolean = false; isShowacn: boolean = false; isShowMeetingDate: boolean = false;
  isShowgstRegistered: boolean = false; isShowopportunityJobs: boolean = false;
  isShowlastInvoiceSent: boolean = false; isShowannualIncome: boolean = false;
  isShowassigneeCount: boolean = false;
}

export class dropdownSettingsConfig { 
  singleSelection: boolean; 
  idField: string; 
  textField: string; 
  selectAllText: string; 
  unSelectAllText: string; 
  itemsShowLimit?: number; 
  allowSearchFilter: boolean;
  enableCheckAll?: boolean;
}

export const dropdownSettings = {
  singleSelection: false,
  idField: 'entityId',
  textField: 'entityName',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 4,
  allowSearchFilter: true,
}

export const dropdownSettings1 = {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 2,
  allowSearchFilter: true       
};
export const dropdownSettingsdebclient1 = {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  enableCheckAll: false,
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 2,
  allowSearchFilter: true
};
export const dropdownSettingsCLientGroup = {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  enableCheckAll: false,
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  //itemsShowLimit: 2,
  allowSearchFilter: true
}
export const dropdownSettingstag = {
  singleSelection: false,
  idField: 'tagsId',
  textField: 'tagname',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 2,
  allowSearchFilter: true
};

export const TagSettings = {
  singleSelection: false,
  idField: 'tagId',
  textField: 'tagname',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 2,
  allowSearchFilter: true,
  disabledField: 'disabled'
}
export const CreateclientTag = {
  singleSelection: false,
  idField: 'grouptagId',
  textField: 'grouptagname',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 6,
  allowSearchFilter: true,
}

export const dynamicFilterList = [
  { id: '1', Name: 'Tag' }, { id: 2, Name: 'Location' }, { id: 3, Name: 'Partner' }, { id: 4, Name: 'Manager' }, { id: 5, Name: 'Is Tax Client' }, { id: 6, Name: 'Tax Agent' }
  , { id: 7, Name: 'Contact Name' }, { id: 8, Name: 'Next Followup Date' }, { id: 9, Name: 'Last Activity Date' }, { id: 10, Name: 'Industry' }, { id: 11, Name: 'GST Registered' }
  , { id: 12, Name: 'Active Jobs' }, { id: 13, Name: 'Number of Opportunity Jobs' }, { id: 14, Name: 'WIP' }, { id: 15, Name: 'Last Invoice Sent' }, { id: 16, Name: 'Annual Income' }
]
export const staticStatusList = [{ StatusId: 1, Name: 'All' }, { StatusId: 2, Name: 'Active' }, { StatusId: 3, Name: 'Archive' }, { StatusId: 4, Name: 'Oppurtunity' }]

export const staticEntityTypeList = [{ EntityTypeId: 1, Name: 'Individual' }, { EntityTypeId: 2, Name: 'Company' }, { EntityTypeId: 3, Name: 'Partnership' }, { EntityTypeId: 4, Name: 'Trust' }, { EntityTypeId: 5, Name: 'SMSF' }]

export enum CheckBoxType { Yes, NO, NONE };
export enum CheckBoxGST { Yes, NO, NONE };
export enum CheckBoxTAX { Yes, NO, NONE };

export class BulkUpdateInfo {
selectedTeam:any = null;
selectedManager:any = null;
selectedPartner:any = null;
checkedClientsCount: number = 0;
updateToValue: any = null;
}

export enum BulkUpdateContextFlags {
Manager = 1,
Partner = 2,
Team = 9,
}

export class ClientDetail {
  clientIds: any;    
  partnerId: string;
  managerId: string
  taxagentId: string
  isTaxclient: any;
  isArchive: any;
  nextMeetingDate: any;
  dueDate: any;
  tagsId: any;
  status: number = 0;
  divisionId: any;
  contextFlag: any;
  contextUser: string;
  statusOwnerId: string;
  teamId: any;
  userId:any;
}

export class ViewFilterBy {
  filterTagId: string = null;
  field: string = '';
  filterValue: any = null;
  filterDisplayValue: any = null;
  headerText: string = '';
  operator: string = '';
  predicate: 'and' | 'or' = 'and';
  matchCase: boolean = false;
  ignoreAccent: boolean = false;
  type?: string = '';
}

export class GetGridViewOptions {
  isLoadDefaultView?: boolean = true;
  isLoadStandardView?: boolean = true;
}

export interface AddressSet {
  addressPoolMappingId: number;
  addressPoolId: number;
  addressTypeId: number;
  careof: string;
  contextId:number;
  contextType: string;
  isFavorite: boolean;
  isDeleted: boolean;
  fullAddressList: any[];
  addressInput$: Subject<string>;
}

export interface AddressData {
  unit: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  country: string;
  postcode: string;
}


export const GetCurrentUserPermissions = () => {
  var userPermissions = {IsclientAdd: false,IsclientUpdate: false,IsclientArchive: false};
  var userPermissionsParsed = JSON.parse(localStorage.getItem('UserPermissions'));
  var privilegeArr = userPermissionsParsed.filter(x => x.area === 'Clients');
  var privilege = JSON.parse(privilegeArr[0].privilege);
  for (var i = 0; i < privilege.length; i++) {
    if (privilege[i].Key == 'Add') {
      userPermissions.IsclientAdd = (privilege[i].Value == "True" ? true : false);
    }
    else if (privilege[i].Key == 'Update') {
      userPermissions.IsclientUpdate = (privilege[i].Value == "True" ? true : false);
    }
    else if (privilege[i].Key == 'Delete') {
      userPermissions.IsclientArchive = (privilege[i].Value == "True" ? true : false);
    }
  }
  return userPermissions;
}

export const defaultCountry = {"countryId": "13","code": "AU","name": "Australia","isdCode": "(+61)"};